export default "__VITE_ASSET__CtZ9uGmY__"